module.exports = __webpack_public_path__ + "img/shop.b08ec9bd.png";